
setTimeout(() => {
  document.querySelectorAll('.social-media-content .col-md-4').forEach(col => {
    function formatNiceDate(dateString) {
        const date = new Date(dateString);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options); // Forces English format
    }

    function parseRelativeTimeToDate(text) {
        const now = new Date();
        const regex = /(\d+)\s+(second|minute|hour|day|week|month|year)s?\s+ago/i;
        const match = text.match(regex);

        if (!match) return null;

        const value = parseInt(match[1], 10);
        const unit = match[2].toLowerCase();

        const date = new Date(now);

        switch (unit) {
            case 'second': date.setSeconds(date.getSeconds() - value); break;
            case 'minute': date.setMinutes(date.getMinutes() - value); break;
            case 'hour':   date.setHours(date.getHours() - value); break;
            case 'day':    date.setDate(date.getDate() - value); break;
            case 'week':   date.setDate(date.getDate() - value * 7); break;
            case 'month':  date.setMonth(date.getMonth() - value); break;
            case 'year':   date.setFullYear(date.getFullYear() - value); break;
        }

        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    }


  // ---------- New sources ----------
  const jMessage     = col.querySelector('.single-feed .j-message');
  const jPosterH3    = col.querySelector('.single-feed .j-poster h3');
  const jPosterImg   = col.querySelector('.single-feed .j-poster img');
  const jImage       = col.querySelector('.single-feed .j-image');
  const jImageImg    = jImage ? jImage.querySelector('img') : null;

  // ---------- Facebook sources ----------
  const fbThumbImg   = col.querySelector('.single-feed .fts-jal-fb-user-thumb img');
  const fbUserName   = col.querySelector('.single-feed .fts-jal-fb-user-name a');
  const fbPostTime   = col.querySelector('.single-feed .fts-jal-fb-post-time');
  const fbMessage    = col.querySelector('.single-feed .fts-jal-fb-message');
  const fbSeeMore    = col.querySelector('.single-feed .fts-jal-fb-see-more');
  const fbPicture    = col.querySelector('.single-feed .fts-jal-fb-picture');
  const fbImg        = col.querySelector('.single-feed .fts-jal-fb-picture img');
  const fbVideo      = col.querySelector('.single-feed .fts-jal-fb-vid-picture');

  // ---------- TikTok sources ----------
  const ttLink       = col.querySelector('.single-feed .fts-tiktok-popup-grab a');
  const ttImg        = col.querySelector('.single-feed .fts-tiktok-popup-grab .fts-twitter-description-image');
  const ttTime       = col.querySelector('.single-feed .fts-tiktok-time');

  // ---------- Twitter sources ----------
  const twName       = col.querySelector('.single-feed .fts-twitter-name-wrap .fts-twitter-full-name');
  const twLogo       = col.querySelector('.single-feed .fts-twitter-username img');

  // ---------- Targets ----------
  const smallLogo    = col.querySelector('.small-logo');
  const textP        = col.querySelector('.social-media-text p');
  const date         = col.querySelector('.date');
  const textH4       = col.querySelector('.social-media-text h4');
  const greenLink    = col.querySelector('.green-link');
  const mainWrap     = col.querySelector('.main-img-wrapper');
  const mainImg      = col.querySelector('.main-img-wrapper .main-img');

  
// ---------- New mappings ----------
const twText = col.querySelector('.single-feed .fts-twitter-text');
if (twText && textH4 && !textH4.textContent.trim()) {
  let msg = twText.textContent.trim();
  if (msg.length > 40) {
    msg = msg.slice(0, 40) + '…';
  }
  textH4.textContent = msg;
}

    const jDate = col.querySelector('.single-feed .j-date');
    const dateTarget = col.querySelector('.date');

    if (jDate && dateTarget && jDate.hasAttribute('datetime')) {
      const formatted = formatNiceDate(jDate.getAttribute('datetime'));
      dateTarget.textContent = formatted;
    }


  if (jMessage && textH4 && !textH4.textContent.trim()) {
    let msg = jMessage.textContent.trim();
    if (msg.length > 40) {
      msg = msg.slice(0, 40) + '…';
    }
    textH4.textContent = msg;
  }

  if (jPosterH3 && textP && !textP.textContent.trim()) {
    textP.textContent = jPosterH3.textContent;
  }

  if (jPosterImg && smallLogo && !smallLogo.getAttribute('src')) {
    smallLogo.src = jPosterImg.src;
  }

  if (jImage && greenLink && jImage.href) {
    greenLink.href = jImage.href;
  }

  if (jImageImg && mainImg && !mainImg.getAttribute('src')) {
    mainImg.src = jImageImg.src;
  }

  if (jImage && mainWrap && jImage.href) {
    mainWrap.href = jImage.href;
  }


  // ---------- Facebook mapping ----------
  if (fbThumbImg && smallLogo && !smallLogo.getAttribute('src')) {
    smallLogo.src = fbThumbImg.src;
  }

  if (fbUserName && textP && !textP.textContent.trim()) {
    textP.textContent = fbUserName.textContent;
  }

  if (fbPostTime && date) {
      const formatted = parseRelativeTimeToDate(fbPostTime.textContent.trim());
      if (formatted) {
        date.textContent = formatted;
      }
  }
  
    if (fbMessage && textH4 && !textH4.textContent.trim()) {
        let msg = fbMessage.textContent.trim();
        if (msg.length > 40) {
            msg = msg.slice(0, 40) + '…';
        }
        textH4.textContent = msg;
    }

  if (fbSeeMore && greenLink) {
    if (!greenLink.textContent.trim()) {
      greenLink.textContent = fbSeeMore.textContent;
    }
    if (fbSeeMore.href) greenLink.href = fbSeeMore.href;

    greenLink.querySelectorAll('svg').forEach(svg => svg.remove());

    greenLink.insertAdjacentHTML('beforeend', `
      <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.94363 7.07905L11.2357 4.78697C11.5075 4.51514 11.5075 4.07441 11.2357 3.80258L8.94363 1.5105M11.0318 4.29478L1.28687 4.29478" stroke="#4CAF4F" stroke-width="1.0441" stroke-linecap="round"></path>
      </svg>
    `);
  }

  if (fbPicture && fbPicture.href && mainWrap) {
    mainWrap.href = fbPicture.href;
  }

  if (fbImg && mainImg && !mainImg.getAttribute('src')) {
    mainImg.src = fbImg.src;
  }

  if (fbVideo && mainImg && !mainImg.getAttribute('src')) {
    const videoImg = fbVideo.querySelector('img');
    if (videoImg) {
      mainImg.src = videoImg.src;
    }
  }

  if (fbSeeMore && fbSeeMore.href && mainWrap) {
    mainWrap.href = fbSeeMore.href;
  }

  // ---------- TikTok mapping ----------
  if (ttLink && ttLink.href && mainWrap) {
    mainWrap.href = ttLink.href;
  }

  if (ttImg && mainImg && !mainImg.getAttribute('src')) {
    mainImg.src = ttImg.src;
  }

    if (ttTime && dateTarget) {
      const formatted = parseRelativeTimeToDate(ttTime.textContent.trim());
      if (formatted) {
        dateTarget.textContent = formatted;
      }
    }

  // ---------- Twitter mapping ----------
  if (twName && textP && !textP.textContent.trim()) {
    textP.textContent = twName.textContent;
  }

  if (twLogo && smallLogo && !smallLogo.getAttribute('src')) {
    smallLogo.src = twLogo.src;
  }
});
}, 500);

